"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExternalDocumentTypeToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformExternalDocumentTypeToString(externalDocumentType) {
    switch (externalDocumentType) {
        case legacy_enums_1.ExternalDocumentType.IDENTITY_PROOF:
            return "mangopay identity proof";
        case legacy_enums_1.ExternalDocumentType.REGISTRATION_PROOF:
            return "mangopay registration proof";
        case legacy_enums_1.ExternalDocumentType.ADDRESS_PROOF:
            return "mangopay address proof";
        case legacy_enums_1.ExternalDocumentType.ARTICLES_OF_ASSOCIATION:
            return "mangopay articles of association";
        case legacy_enums_1.ExternalDocumentType.SHAREHOLDER_DECLARATION:
            return "mangopay shareholder declaration";
        default:
            return "unknown";
    }
}
exports.transformExternalDocumentTypeToString = transformExternalDocumentTypeToString;
//# sourceMappingURL=transformExternalDocumentTypeToString.js.map